import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService, ShopAddress } from '../auth.service';

@Component({
  selector: 'app-shopaddress',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './shopaddress.component.html',
  styleUrl: './shopaddress.component.css'
})
export class ShopaddressComponent implements OnInit {
  addresses: ShopAddress[] = [];
  currentAddress: ShopAddress; // Set as a non-nullable object
  userId!: number; // User ID for demonstration
  errorMessage: string = ''; // For error handling
  isUpdating: boolean = false; // Flag to determine if we're updating

  constructor(private shopAddressService: AuthService) {
    this.currentAddress = this.initializeAddress(); // Initialize with default values
  }

  ngOnInit() {
    this.userId = this.getCurrentUserId(); // Retrieve the current user's ID
    this.loadShopAddresses(); // Load addresses on initialization
  }

  // Method to get the current user's ID
  private getCurrentUserId(): number {
    // Implement logic to get the current user's ID, e.g., from a user service
    return 1; // Replace this with actual user ID retrieval logic
  }

  // Method to initialize a new address
  private initializeAddress(): ShopAddress {
    return {
      userId: this.userId,
      address: '',
      email: '',
      city: '',
      state: '',
      country: '',
      zipcode: '',
      phone: 0,
      cardname: '',
      cardnum: 0,
      cardexp: '',
      cvv: 0,
      status: true,
    };
  }

  // Method to load the user's shop addresses
  loadShopAddresses() {
    this.shopAddressService.getShopAddressesByUserId(this.userId).subscribe(
      (addresses) => (this.addresses = addresses),
      (error) => {
        this.errorMessage = 'Error fetching addresses.';
        console.error('Error fetching addresses:', error);
      }
    );
  }

  // Method to create a new address
  createShopAddress() {
    this.shopAddressService.createShopAddress(this.currentAddress).subscribe(
      (address) => {
        this.addresses.push(address); // Add the new address to the list
        this.resetForm();
      },
      (error) => {
        this.errorMessage = 'Error creating address.';
        console.error('Error creating address:', error);
      }
    );
  }

  // Method to prepare for editing an address
  editShopAddress(address: ShopAddress) {
    this.currentAddress = { ...address }; // Clone the address for editing
    this.isUpdating = true; // Set flag to true for update
  }

  // Method to update an existing address
  updateShopAddress() {
    this.shopAddressService.updateShopAddress(this.currentAddress.id!, this.currentAddress).subscribe(
      (updatedAddress) => {
        const index = this.addresses.findIndex((addr) => addr.id === updatedAddress.id);
        if (index !== -1) {
          this.addresses[index] = updatedAddress; // Update the address in the list
        }
        this.resetForm();
      },
      (error) => {
        this.errorMessage = 'Error updating address.';
        console.error('Error updating address:', error);
      }
    );
  }

  // Method to delete an address
  deleteShopAddress(id: number) {
    this.shopAddressService.deleteShopAddress(id).subscribe(
      () => {
        this.addresses = this.addresses.filter((addr) => addr.id !== id);
      },
      (error) => {
        this.errorMessage = 'Error deleting address.';
        console.error('Error deleting address:', error);
      }
    );
  }

  // Method to reset the edit form
  resetForm() {
    this.currentAddress = this.initializeAddress(); // Reset with default values
    this.isUpdating = false; // Reset update flag
  }
}
